export const SET_PLACES      = 'SET_PLACES';

export const setPlaces = (places) => {
    return {
        type  : SET_PLACES,
        places: places
    }
};


// WEBPACK FOOTER //
// ./src/actions/PlacesAction.js